type SearchIconProps = {
  className?: string;
  fill?: string;
};

const SearchIcon = ({ className, fill = "#212121" }: SearchIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Magnifying glass to indicate Search</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.71 14H15.5L19.74 18.26C20.15 18.67 20.15 19.34 19.74 19.75C19.33 20.16 18.66 20.16 18.25 19.75L14 15.5V14.71L13.73 14.43C12.33 15.63 10.42 16.25 8.39002 15.91C5.61002 15.44 3.39002 13.12 3.05002 10.32C2.53002 6.09002 6.09002 2.53002 10.32 3.05002C13.12 3.39002 15.44 5.61002 15.91 8.39002C16.25 10.42 15.63 12.33 14.43 13.73L14.71 14ZM5.00002 9.50002C5.00002 11.99 7.01002 14 9.50002 14C11.99 14 14 11.99 14 9.50002C14 7.01002 11.99 5.00002 9.50002 5.00002C7.01002 5.00002 5.00002 7.01002 5.00002 9.50002Z"
      fill={fill}
    />
  </svg>
);

export default SearchIcon;
